import React from 'react'
import Header1 from './Header1'
import Banner1 from './Banner1'
import Section1 from './Section1'
import Section2 from './section2'
import Downloadapp from'./Downloadapp'
import Testimonial from'./Testimonial'



import Cardsection from './Cardsection'
import Footer from './Footer'

const Home1 = () => {
  return (
   <>
  <Header1/>
  <Banner1/>
  <Section1/>
  <Cardsection/>
  <Section2/>
  <Downloadapp/>
  <Testimonial/>
  <Footer/>


   </>
  )
}

export default Home1